export const DEFAULT_BATTLE_SIM_CONFIG = {
  version: 1,
  rowOrder: ["front", "mid", "back", "special"],
  rowLabels: {
    front: "Front Row",
    mid: "Mid Row",
    back: "Back Row",
    special: "Special Layer",
  },
  rowGeometry: {
    front: { y: 60, centerX: 50, columnStep: 12, maxColumns: 4 },
    mid: { y: 72, centerX: 50, columnStep: 11, maxColumns: 5 },
    back: { y: 84, centerX: 50, columnStep: 12, maxColumns: 4 },
    special: { y: 95, centerX: 50, columnStep: 11, maxColumns: 3 },
  },
  rowLayouts: {
    front: {},
    mid: {},
    back: {},
    special: {},
  },
  layoutRules: {
    defenderTransform: "rotate-180",
    reflowPolicy: "compact-center",
    keepRelativeOrder: true,
    presenceOverrides: {
      front: {},
      mid: {},
      back: {},
      special: {},
    },
    presenceOrderOverrides: {
      front: {},
      mid: {},
      back: {},
      special: {},
    },
  },
  limitsPolicy: {
    zombieAutoFill: true,
    troopLimitExcludes: ["zombie", "warplane", "maleTitan", "femaleTitan"],
  },
  troopDefinitions: [],
  presets: {
    attacker: {},
    defender: {},
    basic: {
      attacker: {},
      defender: {},
    },
  },
  combatProfiles: {},
};

export const createArmyState = (troopDefinitions = [], seed = {}) => {
  const state = {};
  troopDefinitions.forEach((troop) => {
    const rawValue = seed[troop.id];
    const numeric = Number(rawValue);
    state[troop.id] = Number.isFinite(numeric) && numeric >= 0 ? Math.floor(numeric) : 0;
  });
  return state;
};
